import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import React from 'react';
import { StyledHamburgerIcon } from './hamburgerIcon.style';

export const HamburgerIcon: React.FC<IconsProps> = ({ onClick, fill = '#000000' }) => (
    <StyledHamburgerIcon
        data-testid="hamburger-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.333008 6.17212C0.333008 5.65435 0.752741 5.23462 1.27051 5.23462H22.7294C23.2471 5.23462 23.6669 5.65435 23.6669 6.17212C23.6669 6.68989 23.2471 7.10962 22.7294 7.10962H1.27051C0.752741 7.10962 0.333008 6.68989 0.333008 6.17212ZM0.333008 12.9999C0.333008 12.4822 0.752741 12.0624 1.27051 12.0624H22.7294C23.2471 12.0624 23.6669 12.4822 23.6669 12.9999C23.6669 13.5177 23.2471 13.9374 22.7294 13.9374H1.27051C0.752741 13.9374 0.333008 13.5177 0.333008 12.9999ZM0.333008 19.8278C0.333008 19.31 0.752741 18.8903 1.27051 18.8903H22.7294C23.2471 18.8903 23.6669 19.31 23.6669 19.8278C23.6669 20.3455 23.2471 20.7653 22.7294 20.7653H1.27051C0.752741 20.7653 0.333008 20.3455 0.333008 19.8278Z"
            fill={fill}
        />
    </StyledHamburgerIcon>
);
